import React from 'react';

import TypographyBox from '../TypographyBox/TypographyBox';

const Small = ({ children, ellipsis, textTransform, ...props }) => {
  return (
    <TypographyBox
      ellipsis={ellipsis}
      texttransform={textTransform}
      component="small"
      fontSize="12px"
      fontWeight="500"
      lineHeight="1.5"
      {...props}
    >
      {children}
    </TypographyBox>
  );
};

export default Small;
